import {gql} from 'apollo-angular';
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";
import {ContactGalleryFragment} from "./fragments/ContactGallery";
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_GAME_TIME_LEFT = gql`
  query GetGameTimeLeft($schoolClassId: Int!) {
    getGameTimeLeft(schoolClassID: $schoolClassId) {
      status {
        type
        message
      }
      intValue
    }
  }
`;
